
import { defineComponent } from 'vue'
import AsahiTypography from '@/components/library/Typography.vue'
import closeSvgIcon from '@/components/library/assets/close.svg'
import addSquareSvgIcon from '@/assets/icons/add-square.svg'
import checkRingSvgIcon from '@/assets/icons/check_ring.svg'
import minusCircleSvgIcon from '@/assets/icons/minus-circle.svg'

interface IRoleAccess {
  role: string,
  access: string
}
interface IFeatureRoleMap {
  feature: string,
  roleAccessList: Array<IRoleAccess>
}

const response = `[
    {
        "customerType": "WHSL",
        "roles": [
            {
                "rolename": "WHS Delegated owner",
                "permission": "Home Page,My Profile,Contracts,Reporting,My Orders,Catalogue,Marketing Materials,News & Articles,Support,Academy,Access Management",
                "optional":""
            },
            {
                "rolename": "WHS Warehouse manager",
                "permission": "Home Page,My Profile,Reporting,My Orders,Catalogue,Marketing Materials,News & Articles,Support,Academy",
                "optional":""
            },
            {
                "rolename": "WHS Accountant",
                "permission": "Home Page,My Profile,My Orders,Marketing Materials,News & Articles,Support,Academy",
                "optional":""
            },
            {
                "rolename": "WHS Common user",
                "permission": "Home Page,My Profile,Marketing Materials,News & Articles,Academy",
                "optional":""
            }
        ]
    },
    {
        "customerType": "POS",
        "roles": [
            {
                "rolename": "POS Delegated owner",
                "permission": "Home Page,Catalogue,My Profile,Contracts,Reporting,My Orders,Marketing Materials,News & Articles,Support,Academy,Pub Menu,Access Management,POSM",
                "optional":""
            },
            {
                "rolename": "POS Associate",
                "permission": "Home Page,Catalogue,My Profile,Reporting,My Orders,Marketing Materials,News & Articles,Support,Academy,Pub Menu,Access Management",
                "optional":"POSM"
            },
            {
                "rolename": "POS Shift leader",
                "permission": "Home Page,My Profile,My Orders,Marketing Materials,News & Articles,Support,Academy,Pub Menu",
                "optional":""
            },
            {
                "rolename": "POS Accountant",
                "permission": "Home Page,My Profile,Contracts,Reporting,My Orders,Support,Academy",
                "optional":""
            },
            {
                "rolename": "POS Common user",
                "permission": "Home Page,My Profile,News & Articles,Academy",
                "optional":""
            }

        ]
    },
    {
        "customerType": "On Premise",
        "roles": [
            {
                "rolename": "On Premise Basic",
                "permission": "Home Page,My Profile,News & Articles,About Peroni,Marketing Materials,Support,My Documents,Reporting",
                "optional":"Catalogue,Loyalty"
            },
            {
                "rolename": "On Premise Associate",
                "permission": "Home Page,My Profile,News & Articles,About Peroni,Marketing Materials,Support,Catalogue,My Orders,My Documents,Reporting,Contracts",
                "optional":"Catalogue,Loyalty"
            },
            {
                "rolename": "On Premise Delegated owner",
                "permission": "Home Page,My Profile,Access Management,News & Articles,About Peroni,Marketing Materials,Support,Catalogue,My Orders,My Documents,Reporting,Contracts",
                "optional":""
            },
            {
                "rolename": "On Premise Owner",
                "permission": "Home Page,My Profile,Access Management,News & Articles,About Peroni,Marketing Materials,Support,Catalogue,My Orders,My Documents,Reporting,Contracts",
                "optional":""
            }


        ]
    }
]`

export default defineComponent({
  name: 'RoleDescription',
  components: {
    AsahiTypography
  },
  props: {
    isConsentPopup: {
      type: Boolean,
      default: false
    },
    customerType: {
      type: String,
      required: true
    },
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    }
  },
  data: () => ({
    closeSvgIcon,
    addSquareSvgIcon,
    checkRingSvgIcon,
    minusCircleSvgIcon,
    selectedRole: '',
    roleList: [] as Array<string>,
    featureRoleMapList: [] as Array<IFeatureRoleMap>
  }),
  computed: {

  },
  methods: {
    prepareTableData () {
      const responseObj = JSON.parse(response)
      const customerTypeObj = responseObj.find((customerTypeItem: any) => customerTypeItem.customerType === this.customerType)
      this.roleList = customerTypeObj?.roles?.map((role: any) => role.rolename)
      const permissionList = ['Catalogue', 'My Orders', 'Access Management', 'Contracts', 'Reporting', 'Marketing Materials', 'Support', 'Academy', 'POSM']
      if (permissionList.length > 0) {
        permissionList.forEach((permissionItem: any) => {
          const featureRoleMapObj = {} as IFeatureRoleMap
          featureRoleMapObj.feature = permissionItem
          featureRoleMapObj.roleAccessList = [] as Array<IRoleAccess>
          customerTypeObj.roles.forEach((roleItem: any) => {
            const roleAccess: IRoleAccess = {} as IRoleAccess
            roleAccess.role = roleItem.rolename
            roleAccess.access = 'no'
            if (roleItem.permission.includes(permissionItem)) {
              roleAccess.access = 'yes'
            }
            if (roleItem.optional.includes(permissionItem)) {
              roleAccess.access = 'optional'
            }
            featureRoleMapObj.roleAccessList.push(roleAccess)
          })
          this.featureRoleMapList.push(featureRoleMapObj)
        })
      }
    },

    init () {
      this.prepareTableData()
    },
    close () {
      this.closeModal()
      this.$emit('close')
    }
  },
  mounted () {
    this.init()
  }
})
